import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { AutenticacionService } from './autenticacion.service';
import {PoliticaPerfil} from '../_models/politica-perfil';

@Injectable({
  providedIn: "root",
})
export class PoliticasPerfilService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasPerfiles";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listadoPoliticaPerfil() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as PoliticaPerfil[]));
  }

  listadoPoliticaPerfilHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as PoliticaPerfil[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as PoliticaPerfil));
  }

  listadoIdPolitica(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica)
      .pipe(map((res) => res as PoliticaPerfil[]));
  }

  listadoIdPoliticaEnabled(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica + "/enabled" )
      .pipe(map((res) => res as PoliticaPerfil[]));
  }

  crear(regCrear: PoliticaPerfil) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as PoliticaPerfil));
  }

  actualizar(regActualizar: PoliticaPerfil) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as PoliticaPerfil));
  }

  bulk(registros: PoliticaPerfil[]) {
    registros.map((s: PoliticaPerfil) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + "/bulk", registros)
      .pipe(map((res) => res as PoliticaPerfil[]));
  }
}
